// NotFound.js - 404 page
// Shown when someone visits a URL that doesn't exist
// Keeps the experience branded and gives users a clear path back

import React from 'react';
import { useNavigate } from 'react-router-dom';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="notfound-page">

      {/* Logo links back to landing page */}
      <a href="/" className="auth-logo">Evermark Memorial</a>

      <div className="notfound-card">

        {/* Large 404 number */}
        <div className="notfound-number">404</div>

        {/* Flower emoji as a soft visual */}
        <div className="notfound-icon">🌸</div>

        <h2>This page doesn't exist</h2>
        <p>
          The page you're looking for may have been moved or doesn't exist.
          Let's get you back to somewhere familiar.
        </p>

        {/* Navigation options */}
        <div className="notfound-buttons">
          <button
            className="btn-primary"
            onClick={() => navigate('/')}
          >
            Go to Home
          </button>
          <button
            className="btn-outline"
            onClick={() => navigate('/dashboard')}
          >
            Go to Dashboard
          </button>
        </div>

      </div>
    </div>
  );
}

export default NotFound;